export const bootstrappedData = ((globalThis as any).window as Window)?.BOOTSTRAPPED_DATA ?? {};
